<template>
  <!--<div>-->
    <div class="clearfix navbar">
      <!--Navbar for main navigation.-->
      <div style="margin-top: -1em; position: absolute; font-family: 'Remingtoned Type'">{{ timestamp }}</div>
      <div class="sidenav">
        <!--PLACE ICON HERE-->
        <a href="https://flyingtincans.com/">
          <img class="iconImage" src="../assets/images/logo.png"/>
        </a>
      </div>
      <div style="font-family: 'Remingtoned Type'" class="center-content full-height text-align-center">
        <div class="inline-block margin-auto width-90 full-height vertical-middle">
          <nav class="navigationList inline-block">
            <ul>
              <!--Use <router-link :to="{...}">...</router-link> format for links.-->
              <!--Please reference the routes by name.-->
              <!--Use CamelCase for route names.-->
<!--          <li><a href="https://flyingtincans.com/" >Home</a></li>-->
<!--          <li>|</li>-->
              <li><router-link :to="{name: 'Home'}">Office</router-link></li>
<!--              <li>|</li>-->
              <li><router-link :to="{name: 'AboutUS'}">Documentation</router-link></li>
<!--              <li>|</li>-->
<!--              <li><a href="https://forum.flyingtincans.com/" >Forums</a></li>-->
<!--              <li>|</li>-->
              <li><router-link :to="{name: 'CampaignList'}">Campaigns</router-link></li>
<!--              <li>|</li>-->
              <li><router-link :to="{name: 'Units'}">Rosters</router-link></li>
<!--              <li>|</li>-->
<!--              <li><router-link :to="{name: 'Members'}">Members</router-link></li>-->
<!--              <li>|</li>-->
              <li><router-link :to="{name: 'UnitOverview'}">Administration</router-link></li>
              <!--<li v-if="isAdmin()"><router-link :to="{name: 'Admin'}">Administration</router-link></li>-->
              <!--<li><router-link :to="{name: 'FlightSchool'}">FlightSchool</router-link></li>-->
            </ul>
          </nav>
          <Logger class="logger"></Logger>
        </div>
      </div>
      <div class="sidenav-right">
      <a href="https://forum.flyingtincans.com/">
        <img align="right" class="iconImage" src="../assets/images/forum-icon.png"/>
      </a>
        <div style="margin-right: 1em; font-size: larger; font-family: 'Remingtoned Type'" class="sidenav-right">{{this.$session.get('username')}}</div>
      </div>
    </div>

</template>

<script>
import Logger from './Logger'

export default {
  name: 'Navbar',
  components: {
    Logger
  },
  data() {
    return {
      timestamp: ""
    }
  },
  created() {
    setInterval(this.getNow, 1000);
  },

  methods: {
    getNow: function() {
      const today = new Date();
      const date = today.getUTCFullYear()+'-'+(today.getUTCMonth()+1)+'-'+today.getUTCDate();
      const time = today.getUTCHours() + ":" + today.getUTCMinutes() + " " +  "Z";
      const dateTime = date +' '+ time;
      this.timestamp = dateTime;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.iconImage {
  max-height: 90px;
}

.navbar {
  min-height: 90px;
  width: calc(100% - 20px); /* Whished widht in % minus 2x border size */
  padding: 10px;
}

.navigationList li {
  display: table-cell;
  font-size: 125%;
  text-align: center;
}

.navigationList li a {
  padding: 0px 20px;
  text-decoration: none;
  font-weight: bold;
  color: #1a1a1a;
}

.navigationList li a:hover{
  color: #FFF6FD;
}

.logger {
  padding: 2px;
  border-radius: 15px;
  background: rgba(0, 0, 0, 0.1);
  vertical-align: bottom;
}

</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue